class CssHelper {
    static createCssClass = (string: string) => {
        return string
            .replace(/\s+/g, " ")
            .trim();
    }

    static getHighlightedText = (text: string, highlight: string) => {
        const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
        
        return <>
            { text }
            {/* {
                parts
                    .map(
                        part =>
                        part.toLowerCase() === highlight.toLowerCase()
                        ? <b>{part}</b>
                        : part
                    )
            } */}
        </>;
    }
}

export default CssHelper;